import {bootstrapModal} from "../lib/bootstrapModal";
import {Messages} from "../messages/Messages";
import {apiPostForAjaxResponse} from "../lib/SecuredAjax";
import {AppConfig} from "../AppConfig";
import {fetchJson, isAjaxResponseOk, toastFetchError} from "../lib/fetch";
import {showToastInfo} from "../lib/boostrapToast";
import {PositionSelectOption} from "../dto/com.rico.sb2.service.positions";
import {escapeHTML} from "../lib/escapeHTML";
import {coalesce} from "../lib/coalesce";

const messages = new Messages();

export class SendContainerToWork {
	private readonly containerId: number;
	private readonly currentPosition: number | null;

	constructor(containerId: number, currentPosition: number | null) {
		this.containerId = containerId;
		this.currentPosition = currentPosition;
	}

	private execute(enteredTarget: number | null): Promise<void> {
		return new Promise((resolve, reject) => {
			apiPostForAjaxResponse(`${AppConfig.CP}/op/sendToWork`, {container: this.containerId, enteredTarget: enteredTarget})
				.then(res => {
					if (!res) return Promise.reject(500)

					if (res.generator) {
						const {pathVariations, checkedVariations} = res.generator;
						const checkedPercent = pathVariations > 0 ? Math.round(checkedVariations * 100 / pathVariations) : 0;
						showToastInfo(messages.get('SendContainerToWork.completeNoticeWithGenerator', checkedVariations, pathVariations, checkedPercent))
					} else {
						showToastInfo(messages.get('SendContainerToWork.completeNotice'))
					}

					resolve()
				})
				.catch(toastFetchError)
				.then(() => reject());
		})
	}

	showModal(completer?: Function) {
		const defaultUnloading = AppConfig.defaultUnloadInStart ? this.currentPosition : 0;

		fetchJson(`${AppConfig.CP}/op/listUnloadTargets?container=${this.containerId}`)
			.then((res: any) => isAjaxResponseOk(res) ? res.value : Promise.reject(500))
			.then((positions: PositionSelectOption[]) => {
				let finishPositionOptions = `<option value="">${escapeHTML(messages.get('UpdateContainerMessage.enteredTargetPosition.any'))}</option>`;
				const currentSuffix = ` ${escapeHTML(messages.get("UpdateContainerMessage.enteredTargetPosition.currentSuffix"))}`
				if (positions.length > 0) {
					finishPositionOptions += positions
						.sort((a, b) => coalesce(a.label, '').localeCompare(b.label))
						.map((p: any) => `<option value="${p.id}" ${defaultUnloading == p.id ? 'selected' : ''}>${escapeHTML(p.code)}: ${escapeHTML(p.label)}${this.currentPosition == p.id ? currentSuffix : ''}</option>`)
						.join("")
				}
				this.startModal(finishPositionOptions, completer);
			})
			.catch(toastFetchError)
	}

	private startModal(finishPositionOptions: string, completer?: Function) {
		const {modal, content, buttonOk, buttonOkClickStart, buttonOkClickFinish} = bootstrapModal({
			title: messages.get('SendContainerToWork.confirmNotice', this.containerId),
			body: `
<div>
		<label for="targetPosition" class="form-label">Позиция выгрузки</label>
		<select name="targetPosition" class="form-select" required></select>
</div>
			`,
			footer: `
				<div class="flex-fill"></div>
				<button type="button" class="btn btn-primary text-capitalize" data-handler="submit">${messages.get('button.send')}</button>
				<button type="button" class="btn btn-secondary text-capitalize" data-bs-dismiss="modal">${messages.get('button.cancel')}</button>
			`
		});
		modal.show();

		const targetPositionSelect = content.querySelector<HTMLSelectElement>(`select[name="targetPosition"]`)!!
		targetPositionSelect.innerHTML = finishPositionOptions;

		const ok = buttonOk!!;

		ok.addEventListener('click', () => {
			buttonOkClickStart();

			const enteredTargetSelection = parseInt(targetPositionSelect.value)
			const enteredTarget = isFinite(enteredTargetSelection) ? enteredTargetSelection : null;

			this.execute(enteredTarget)
				.then(() => {
					modal.hide()
					if (completer) completer()
				})
				.catch(buttonOkClickFinish)
		})
	}
}
